import { render } from "./AllStudentsInGroup.vue?vue&type=template&id=2a0bc0b1"
import script from "./AllStudentsInGroup.vue?vue&type=script&lang=js"
export * from "./AllStudentsInGroup.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__